<template>
  <div>
    <!-- 头部 -->
    <top></top>
      <!-- logo -->
      <div class="logo">
         <img v-if="bannerArr.length>0" class="banner" :src="$imgUrl+bannerArr[0].thumb" alt="" />
      </div>
      <div class="container">
          <div class="recruitmentDetails_top">
            <div class="top1">
              <span>{{ companyRecruit.position }}</span>
              <span>{{ langSet=='cn'?'投递邮箱':'Drop Off Box'}}：{{ companyRecruit.delivery }}</span>
            </div>
            <!-- <div class="price"><span>{{ langSet=='cn'?'月薪':'Monthly Salary'}}</span><span>20-25k/{{ langSet=='cn'?'月':'month'}}</span></div> -->
          </div>
          <div class="recruitmentDetails_top_line"></div>
         
          <div class="desc" v-html="companyRecruit.describe"></div>
      </div>
    <!-- 底部 -->
    <bottom></bottom>
  </div>
</template>

<script>
import top from "../../components/top.vue";
import bottom from "../../components/bottom.vue";

import {getBanner,getcompanyRecruit} from "@/api/api";


export default {
  components: { top, bottom },
  name: "home",
  // 配置title和meta数据
  metaInfo() {
    return {
      title: 'BCEIA-招聘详情',
      meta: [
        { 
          name: 'description', 
          content: '招聘详情招聘详情招聘详情' 
        }
      ]
    }
  },
  data() {
    return {
      langSet:'',
      bannerArr:[],
      id:'',
      companyRecruit:{}
    };
  },
  created() { },
  mounted() {
    this.langSet = localStorage.getItem("languageSet") || "cn";
    this.id=this.$route.query.id;
    this.getBannerList()
    this.getcompanyRecruit()
  },
  methods: {
      // zhang 获取关于展会banner
  getBannerList(){
      let data={
        class:'展商列表',
        lang_type: this.langSet
      }
      getBanner(data).then(res=>{
        if(res.code == 1){
          this.bannerArr=res.data.lists;
        }
          
      }).catch(err=>{
        console.log(err)
      })
    },
       // zhang 获取最新动态数据
       getcompanyRecruit(){
            let data={
                id:this.id
            }
            getcompanyRecruit(data).then(res=>{
                if(res.code == 1){
                this.companyRecruit=res.data;
                
                }
                
            }).catch(err=>{
                console.log(err)
            })
        
        },
  },
};
</script>

<style lang="scss" scoped>
.logo{
    width: 100%;
    height: 600px;
    img{
      width: 100%;
      height: 600px;
    }
}
.container{
  // width: 1280px;
  margin: 80px auto;
  background:#fff;
  .recruitmentDetails_top_line{
    width: 100%;
    border: 1px dashed #999999;
    margin: 30px 0;
  }
  .desc{
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #757575;
    line-height: 20px;
  }
  .recruitmentDetails_top{
    display: flex;
    justify-content: space-between;
    .top1{
       span:nth-child(1){
         display: inline-block;
         font-family: PingFangSC, PingFang SC;
         font-weight: 600;
         font-size: 28px;
         color: #2C2C2E;
       }
       span:nth-child(2){
          display: inline-block;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 16px;
          color: #2C2C2E;
          margin-left: 80px;
       }
    }
    .price span:nth-child(1){
        display: inline-block;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 16px;
        color: #2C2C2E;
    }
    .price span:nth-child(2){
        display: inline-block;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 18px;
        color: #FF6A0A;
        margin-left: 8px;
    }
  }
}
@media only screen and (max-width: 767px) {
  .logo{
    width: 100%;
    height: 122px;
    margin-top: 0.88rem;
    img{
      width: 100%;
      height: 122px;
    }
    
}
.container .recruitmentDetails_top .top1 span:nth-child(1){
      font-size: 22px !important;
    }
.container .recruitmentDetails_top .top1 span:nth-child(2){
  font-size: 14px !important;
}
.container .desc{
  font-size: 12px;
}
.recruitmentDetails_top{
  flex-wrap: wrap !important;
  .top1 span:nth-child(2){
      margin-left: 15px !important;
  }
  .price{
    margin-top: 15px;
  }
  }
  }

</style>